<template>
  <div class="info-box" :style="baseStyle" >

    <div class="info" :data-show="showInfo" :style="infoStyle" v-if="hover">
      <slot>
        Info text here.
      </slot>
    </div>

    <div class="indicator"><span>i</span></div>

  </div>
</template>

<script>
export default {
  name: "InfoBox",
  props: {
    active: {
      default: true
    },

    hover: {
      default: true
    },

    align: {
      default: "right top"
    },

    left: {
      default: ""
    },

    top: {
      default: ""
    },

    bottom: {
      default: ""
    },

    right: {
      default: ""
    },

    width: {
      default: "auto"
    },

    height: {
      default: "auto"
    },
  },

  data: function(){
    return {
      showInfo: false
    }
  },

  methods: {
    toggleInfo: function(){
      this.showInfo = !this.showInfo;
    }
  },
  computed: {
    baseStyle: function(){

      let style = {};



      if(this.top){
        style.top = this.top;
      }

      if(this.bottom){
        style.bottom = this.bottom;
      }

      if(this.right){
        style.right= this.right;
      }

      if(this.left){
        style.left = this.left;
      }

      if(this.width){
        style.width = this.width;
      }

      if(this.height){
        style.height = this.height;
      }
      return style;
    },

    infoStyle: function(){
      let style = {};

      let alignment = this.align.split(" ");

      let horizontal = alignment[0];
      let vertical = alignment[1];

      if( horizontal == "left"){
        style.left = "100%";
      }

      if( horizontal == "right"){
        style.right = "0%";
      }

      if( horizontal == "middle"){
        style.left = "50%";
        style.transform = "translateX(-50%)";
      }

      if( vertical == "top"){
        style.top = "0%";
      }

      if( vertical == "bottom"){
        style.bottom = "0%";
      }

      if( vertical == "middle"){
        style.top = "50%";
        style.transform = "translateY(-50%)";
      }



      return style;
    }
  }
}
</script>

<style scoped>

@keyframes blink {
  0% {
    transform: scale(1.0);
  }

  50% {
    transform: scale(0.75);
  }

  100% {
    transform: scale(1.0);
  }
}




.info-box {
  font-size: 1.0em;
  position: absolute;

}

.info-box p {
  margin: 0;
}

.info > p + p {
  margin-top: 1em;
}

.indicator {
  width: 2em;
  height: 2em;
  border-radius: 2em;
  background-color: var(--color-green);
  position: absolute;
  top: -0.75em;
  right: -0.75em;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  border: 2px solid white;
  user-select: none;
  cursor: pointer;
  box-sizing: border-box;

  animation: blink 1.0s infinite;
}

.info {
  position: absolute;
  display: none;
  opacity: 0;
  transition: opacity 0.3s;
  padding: 1.5em;
  background-color: var(--color-green);
  color: white;
  width: 100%;
  box-sizing: border-box;

}

.info-box:hover .info {
  display: block;
  opacity: 1.0;
}

.info-box:hover .indicator {

}

</style>